export default __webpack_public_path__ + "static/media/discord.fcb1b31f.png";